import { rusPhoneCode } from '../../constants/constants';
export const validatePhone = ({ value, required }) => {
    if (required && !value) {
        return {
            message: 'Введите номер телефона',
            type: 'submit',
        };
    }
    if (value === rusPhoneCode) {
        return null;
    }
    const patternPhone = /^\+7\d{10}$/;
    if (value && !patternPhone.test(value)) {
        return {
            message: 'Проверьте правильность введеного номера телефона',
            type: 'lostfocus',
        };
    }
    return null;
};
